import { supabase } from '../supabase';

export const getBookings = () =>
  supabase.from('bookings').select('*').order('scheduled_at', { ascending: false });

export const getBooking = (id) =>
  supabase.from('bookings').select('*').eq('id', id).single();

export const createBooking = async (data) => {
  const result = await supabase.from('bookings').insert({
    ...data,
    status: data.status || 'scheduled',
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
  }).select().single();
  await logActivity({
    type: 'booking_created',
    booking_id: result.data?.id,
    client_id: data.client_id,
    note: `Booking created for ${data.client_name || 'client'}`,
  });
  return result;
};

export const updateBooking = async (id, data) => {
  await supabase.from('bookings').update({ ...data, updated_at: new Date().toISOString() }).eq('id', id);
  await logActivity({ type: 'booking_updated', booking_id: id, note: 'Booking updated' });
};

export const deleteBooking = (id) =>
  supabase.from('bookings').delete().eq('id', id);

export const getBookingsByClient = (clientId) =>
  supabase.from('bookings').select('*').eq('client_id', clientId).order('scheduled_at', { ascending: false });

export const getBookingsByStatus = (status) =>
  supabase.from('bookings').select('*').eq('status', status).order('scheduled_at', { ascending: false });

export const logActivity = (data) =>
  supabase.from('activity_log').insert({ ...data, created_at: new Date().toISOString() });
